<template>
  <v-app-bar
    v-if="
      $auth.check() && 
      (
        !['Err404', 'NewExecution', 'ContinueExecution', 'ReviewExecution', 'ExecuteTask', 'ContinueTask'].includes($route.name) && $route.name
      ) && (
        !['/dashboard?tv=true'].includes($route.fullPath)
      )"
    id="core-app-bar"
    app
    color="background"
    dense
    :dark="dark"
    height="60"
    :flat="flat"
  >
    <v-app-bar-nav-icon @click.stop="onClick"></v-app-bar-nav-icon>
    <div @click.stop="onClick" style="cursor:pointer">{{title}}</div>

    <v-spacer />
    <v-toolbar-items>
      <theme-change v-if="oneUser && use_white_label"></theme-change>
      <!-- <bell-badge></bell-badge> -->
      <menu-solution></menu-solution>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { mapActions, mapState } from "vuex";
import responsive from "@/mixins/responsive";
import active_solution from "@/mixins/active_solution";

export default {
  components: {
    BellBadge: () => import("@/_notifications/components/BellBadge"),
    MenuSolution: () => import("@/components/fusion_core/MenuSolution"),
    ThemeChange: () => import("./ThemeChange.vue")
  },
  mixins: [responsive, active_solution],
  data: () => ({
    title: null,
    drawer: false,
    color: "grey lighten-4",
    dark: false,
    flat: false
  }),
  computed: {
    use_white_label() {
      if (this.oneUser && this.oneUser.company) {
        return this.oneUser.company.data.attributes.white_label_config.use_white_label
      }
    },
    ...mapState({
      oneUser: state => state.User.oneUser,
    })
  },
  methods: {
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      console.log("theme => ", this.$vuetify.theme);
    },
    ...mapActions({
      setDrawer: "App/setDrawer"
    }),
    onClick() {
      this.setDrawer(!this.$store.state.App.drawer);
    },
    setToolBar() {
      if (this.isMobile) {
        this.color = "transparent"; //"grey lighten-4"
        this.dark = true;
        this.flat = true;
      } else {
        this.color = "transparent";
        this.dark = true;
        this.flat = true;
      }
    }
  },

  watch: {
    isMobile(val) {
      this.setToolBar();
    },

    $route(to, from) {
      this.title = to.meta.translated;
    }
  },

  mounted() {
    this.title = this.$router.currentRoute.meta.translated;
    this.setToolBar();
  }
};
</script>

<style>
/* Fix coming in v2.0.8 */
#core-app-bar {
  width: auto;
}

#core-app-bar a {
  text-decoration: none;
}
</style>
